module.exports = __webpack_public_path__ + "static/img/ourAppImg4.62f89246.png";